export default __webpack_public_path__ + "static/media/gothenburg_l2.20ea2c09.png";